<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane :label="$t('CargoMsg.Cargo_LoadingPool')" name="loadPool">
          <load-pool
            ref="loadPool"
            :airline-product-down-list="airlineProductDownList"
            :source="SystemConstants.LOAD_POOL_SOURCE_HOME_PAGE.code"
            @saveAssemblyPlanSuccess="saveAssemblyPlanSuccess"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_AssemblyPlan')" name="assemblyPlan">
          <assembly-plan
            ref="assemblyPlan"
            :airline-product-down-list="airlineProductDownList"
            @saveAssemblyPlanSuccess="saveAssemblyPlanSuccess"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { queryAirlineProductDownList } from '@/api/booking/airlineProduct'
import loadPool from '@/views/cargo/v0/AirExport/components/loadManagement/loadPool'
import assemblyPlan from '@/views/cargo/v0/AirExport/components/loadManagement/assemblyPlan'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'LoadManagement',
  components: { loadPool, assemblyPlan },
  data() {
    return {
      SystemConstants,
      activeTabName: 'loadPool',
      airlineProductDownList: [] // 航线产品 下拉
    }
  },
  activated() {
    // 初始化 航线产品下拉列表（航次也查询出来）
    queryAirlineProductDownList({ containVoyage: true, branchId: this.$store.getters.currentOfficeId }).then(res => {
      this.airlineProductDownList = res.data
    })
  },
  methods: {
    saveAssemblyPlanSuccess(assemblyPlanUuid) {
      this.$refs.assemblyPlan.queryHandler()
      this.$refs.assemblyPlan.selectedRow = { uuid: assemblyPlanUuid }
      if (this.$refs.assemblyPlan.view === 'list') {
        this.$refs.assemblyPlan.view = 'detail'
      }
      this.activeTabName = 'assemblyPlan'
    }
  }
}
</script>

<style scoped>

</style>
